lmApp
  .controller('EpgImportController', ['$scope', '$rootScope', '$q', '$timeout', '$routeParams', '$location', '$templateCache', '$compile', 'EpgService', 'ToastService', 'ModalWindowService', 'MetadataService', 'TimezoneService', 'ManagerResource', 'AssetResource', 'ManageEPGChannelsWindow', 'URLService',
    function ($scope, $rootScope, $q, $timeout, $routeParams, $location, $templateCache, $compile, EpgService, ToastService, ModalWindowService, MetadataService, TimezoneService, ManagerResource, AssetResource, ManageEPGChannelsWindow, URLService) {
      var timezone = _.find(TimezoneService.Timezones, {title: 'UTC'});
      $scope.tz = timezone.title;
      ManagerResource.get().$promise
          .then(function (result) {
            if (result.length !== 0) {
              var manager = _.find(result, { username: $rootScope.globals.currentUser.username });
              if (manager) {
                timezone = _.find(TimezoneService.Timezones, { title: manager.ui_timezone || 'UTC' });
                $scope.tz = timezone.title;
              }
            }
          })
          .catch(function (reason) {
            $rootScope.debugInfo(reason, 'silent');
          });

      $scope.convertTime = function (dt) {
        return TimezoneService.addTimezoneToDate(dt, timezone)
      };

      //
      $scope.loading = false;
      $scope.activeSource = {};
      $scope.searchKeyword = '';
      $scope.croneConfig = {
        options: {allowMinute: false, allowHour: false, allowYear: false}
      };
      $scope.epgSourceCollection = [];
      $scope.epgTasksCollection = [];
      $scope.newSource = {
        name: '',
        url: '',
        default_image: ''
      };
      $scope.newImportTask = {
        name: '',
        shown: false,
        _PrivateData: {
          schedule_time: '0 5 * * *',
          source: {},
          channels: [],
          allSources: []
        }
      };

      $scope.activeChannel = {};
      $scope.date = {};
      $scope.channelEvents = [];
      $scope.searchEvent = '';
      $scope.scheduleListView = true;

      var assetCache = {};

      var _parseImportTask = function (task) {
        task._PrivateData = {};
        task.is_active = !!task.is_active;
        task._PrivateData.schedule_time = '';
        for(var i=0; i < task.channels.length; i++) {
          task.channels[i]._lastImportTime = task.channels[i].last_import_time > 0 ? moment.utc(task.channels[i].last_import_time * 1000) : '';
        }
        return task;
      };

      $scope.getImportSourceCollection = function () {
        $scope.loading = true;
        $rootScope.showLinearProgress('#epgSourcesLoader');

        EpgService.GetEpgSources()
          .then(function (collection) {
            $scope.loading = false;
            $rootScope.hideLinearProgress('#epgSourcesLoader');
            $scope.epgSourceCollection = collection.map(function (source) {
              source._PrivateData = {};
              source.url = _.trim(source.url);
              source.name = _.trim(source.name);
              var lastImportTime = '';
              for(var i=0; i < source.channels.length; i++) {
                if (source.channels[i].last_import_time > lastImportTime) {
                  lastImportTime = source.channels[i].last_import_time;
                }
              }
              source._lastImportTime = lastImportTime ? moment.utc(lastImportTime * 1000) : '';
              return source;
            });

            if ($scope.epgSourceCollection.length && $scope.routeSourceId) {
              var source = _.find($scope.epgSourceCollection, {id: $scope.routeSourceId});
              if (source) {
                $scope.setActiveSource(source);
              }
            }
          })
          .catch(function (reason) {
            $scope.loading = false;
            $rootScope.hideLinearProgress('#epgSourcesLoader');
            $rootScope.debugInfo(reason, 'silent');
            ToastService.Small({
              title: 'Sorry, some services are unavailable right now. If you\'re still having problems, try reloading the page',
              color: 'amber',
              icon: 'server-off',
              blocked: true
            }, 1000 * 3);
          });
      };

      $scope.getImportTasksCollection = function (id) {
        $scope.loading = true;
        $rootScope.showLinearProgress('#epgSourceLoader' + id);

        EpgService.GetEpgImportTasks(id)
          .then(function (collection) {
            $scope.loading = false;
            $rootScope.hideLinearProgress('#epgSourceLoader' + id);
            $scope.epgTasksCollection = collection.map(function (task) {
              task._PrivateData = {};
              task._PrivateData.schedule_time = '';
              return task;
            });
          })
          .catch(function (reason) {
            $scope.loading = false;
            $rootScope.hideLinearProgress('#epgSourceLoader' + id);
            $rootScope.debugInfo(reason, 'silent');
            ToastService.Small({
              title: 'Sorry, some services are unavailable right now. If you\'re still having problems, try reloading the page',
              color: 'amber',
              icon: 'server-off',
              blocked: true
            }, 1000 * 3);
          });
      };

      $scope.isActiveSourceSet = function () {
        return !_.isEmpty($scope.activeSource);
      };

      $scope.setActiveSource = function (source) {
        $scope.activeSource = source;
        $scope.getImportTaskDetail(source);
        $location.search('source_id', source.id);
      };

      $scope.clearActiveSource = function () {
        $scope.activeSource = {};
        $location.search('source_id', null);
      };

      $scope.createNewEpgSource = function () {
        if ($scope.loading) return;

        var createTpl = $templateCache.get('create-epg-import.html');
        createTpl = $compile(createTpl)($scope);

        ModalWindowService.Open({
          content: createTpl,
          actions: [
            {
              title: 'Create',
              color: 'green',
              fn: function () {
                $scope.loading = true;
                $rootScope.showLinearProgress('#epgSourcesLoader');

                var defPicture = _.trim($scope.newSource.default_image);
                if (defPicture) {
                  var url = $scope.newSource.url;
                  var urlParts = URLService.parseURL(url);
                  urlParts.params.push({name: "$genericImage", value: [defPicture]});
                  $scope.newSource.url = urlParts.url + '?' + URLService.joinURLParams(urlParts.params);
                }

                EpgService.CreateNewEpgSource($scope.newSource)
                  .then(function (response) {
                    $scope.setActiveSource(response.source);
                    $scope.loading = false;
                    $rootScope.hideLinearProgress('#epgSourcesLoader');
                    $scope.getImportSourceCollection();
                    ToastService.Small({
                      title: 'Source successfully created',
                      color: 'green',
                      icon: 'plus-network'
                    });
                  })
                  .catch(function (reason) {
                    $scope.loading = false;
                    $rootScope.hideLinearProgress('#epgSourcesLoader');
                    ToastService.Small({
                      title: 'Source creation failed',
                      color: 'red',
                      icon: 'plus-network'
                    });
                    $rootScope.debugInfo(reason);
                  });
              },
              show_fn: function () {
                return !!$scope.newSource.url;
              }
            },
            {
              title: 'Cancel',
              color: 'red'
            }
          ]
        });
      };

      $scope.updateEpgSource = function (source) {
        if ($scope.loading) return;

        $scope.loading = true;
        $rootScope.showLinearProgress('#epgSourceLoader' + source.id);

        EpgService.CreateNewEpgSource(source)
          .then(function (response) {
            source.channels = angular.copy(response.source.channels);

            $scope.loading = false;
            $rootScope.hideLinearProgress('#epgSourceLoader' + source.id);
            ToastService.Small({
              title: 'Source successfully updated',
              color: 'green',
              icon: 'refresh'
            });
          })
          .catch(function (reason) {
            $scope.loading = false;
            $rootScope.hideLinearProgress('#epgSourceLoader' + source.id);
            ToastService.Small({
              title: 'Source update failed',
              color: 'red',
              icon: 'refresh'
            });
            $rootScope.debugInfo(reason);
          });
      };

      $scope.deleteEpgSource = function (source) {
        if ($scope.loading) return;

        ModalWindowService.Open({
          content: '<p class="fs-headline tc-red-800">DELETE EPG SOURCE</p> ' +
          '<p class="fs-title">This action will delete source permanently with all imported data. Are You sure?</p>',
          actions: [
            {
              title: 'DO IT',
              color: 'green',
              fn: function () {
                $scope.loading = true;
                $rootScope.showLinearProgress('#epgSourcesLoader');

                EpgService.DeleteEpgImport(source)
                  .then(function () {
                    $scope.loading = false;
                    $rootScope.hideLinearProgress('#epgSourcesLoader');
                    $scope.getImportSourceCollection();
                    $scope.clearActiveSource();
                    ToastService.Small({
                      title: 'Source successfully deleted',
                      color: 'green',
                      icon: 'delete'
                    });
                  })
                  .catch(function (reason) {
                    $scope.loading = false;
                    $rootScope.hideLinearProgress('#epgSourcesLoader');
                    ToastService.Small({
                      title: 'Source delete failed',
                      color: 'red',
                      icon: 'delete'
                    });
                    $rootScope.debugInfo(reason);
                  });
              }
            },
            {
              title: 'Cancel',
              color: 'red'
            }
          ]
        });
      };

      $scope.getImportTaskDetail = function (source) {
        $rootScope.showLinearProgress('#epgSourceLoader' + source.id);
        $scope.loading = true;

        EpgService.GetEpgImportTasks(source.id)
          .then(function (collection) {
            if (collection.length) {
              source._PrivateData.task = _parseImportTask(collection[0]);

              var epgIDs = [];
              for (var i = 0; i < source._PrivateData.task.channels.length; i++) {
                epgIDs.push(source._PrivateData.task.channels[i].id);
              }
              if (epgIDs.length > 0) {
                var params = {
                  'type[eq]': 'channel',
                  'epg.id[in]': epgIDs.join(','),
                  '$expand': 'epg'
                };
                AssetResource.get(params).$promise
                    .then(function (assets) {
                      for (var i=0; i < assets.length; i++) {
                        if (!assetCache.hasOwnProperty(assets[i].epg.id)) {
                          assetCache[assets[i].epg.id] = [];
                        }
                        var asset = _.find(assetCache[assets[i].epg.id], { id: assets[i].id });
                        if (!asset) assetCache[assets[i].epg.id].push(assets[i]);
                      }
                      for (var i=0; i < source._PrivateData.task.channels.length; i++) {
                        source._PrivateData.task.channels[i]._assets = assetCache[source._PrivateData.task.channels[i].id];
                      }
                      $rootScope.hideLinearProgress('#epgSourceLoader' + source.id);
                      $scope.loading = false;
                    })
                    .catch(function (reason) {
                      $rootScope.hideLinearProgress('#epgSourceLoader' + source.id);
                      $scope.loading = false;
                      $rootScope.debugInfo(reason);
                    });
              }
            } else {
              source._PrivateData.task = {
                isNew: true,
                name: '',
                _PrivateData: {
                  schedule_time: '0 5 * * *'
                },
                schedule_time: '0 5 * * *',
                channels: []
              };
              $rootScope.hideLinearProgress('#epgSourceLoader' + source.id);
              $scope.loading = false;
            }
          })
          .catch(function (reason) {
            $scope.loading = false;
            $rootScope.hideLinearProgress('#epgSourceLoader' + source.id);
            $rootScope.debugInfo(reason, 'silent');
            ToastService.Small({
              title: 'Sorry, some services are unavailable right now. If you\'re still having problems, try reloading the page',
              color: 'amber',
              icon: 'server-off',
              blocked: true
            }, 1000 * 3);
          });
      };

      $scope.createEpgImportTask = function (source) {
        if ($scope.loading) return;

        var _ids = [];
        for (var i = 0; i < source._PrivateData.task.channels.length; i++) {
          _ids.push(source._PrivateData.task.channels[i].id);
        }

        $scope.loading = true;
        $rootScope.showLinearProgress('#epgSourceLoader' + source.id);

        EpgService.CreateEpgImportTask(source, source._PrivateData.task, _ids)
          .then(function (response) {
            $scope.loading = false;
            $rootScope.hideLinearProgress('#epgSourceLoader' + source.id);

            $scope.getImportTaskDetail(source);

            ToastService.Small({
              title: 'Task successfully created',
              color: 'green',
              icon: 'plus'
            });
          })
          .catch(function (reason) {
            $scope.loading = false;
            $rootScope.hideLinearProgress('#epgSourceLoader' + source.id);
            ToastService.Small({
              title: 'Task creation failed',
              color: 'red',
              icon: 'plus'
            });
            $rootScope.debugInfo(reason);
          });
      };

      $scope.updateEpgImportTask = function (source) {
        if ($scope.loading) return;

        if (source._PrivateData.task.isNew) {
          return $scope.createEpgImportTask(source);
        }

        var _ids = [];
        for (var i = 0; i < source._PrivateData.task.channels.length; i++) {
          _ids.push(source._PrivateData.task.channels[i].id);
        }

        if (!_ids.length) {
          ToastService.Small({
            title: 'Choose at least one channel',
            color: 'yellow',
            icon: 'alert'
          });
          return;
        }

        $scope.loading = true;
        $rootScope.showLinearProgress('#epgSourceLoader' + source.id);

        EpgService.UpdateEpgImportTask(source, source._PrivateData.task, _ids)
          .then(function () {
            $scope.loading = false;
            $rootScope.hideLinearProgress('#epgSourceLoader' + source.id);
            ToastService.Small({
              title: 'Task successfully updated',
              color: 'green',
              icon: 'refresh'
            });
          })
          .catch(function (reason) {
            $scope.loading = false;
            $rootScope.hideLinearProgress('#epgSourceLoader' + source.id);
            ToastService.Small({
              title: 'Task update failed',
              color: 'red',
              icon: 'refresh'
            });
            $rootScope.debugInfo(reason);
          });
      };

      var manageChannelsFromModal = function (toAdd, toRemove, toThis) {
        var allQ = {};
        var ids = {};
        var channels = [];
        for (var i = 0; i < $scope.activeSource._PrivateData.task.channels.length; i++) {
          ids[$scope.activeSource._PrivateData.task.channels[i].id] = true;
          channels.push($scope.activeSource._PrivateData.task.channels[i]);
        }

        if (toAdd.length) {
          for (var i = 0; i < toAdd.length; i++) {
            if (ids.hasOwnProperty(toAdd[i].id)) {
              continue
            }
            channels.push(toAdd[i]);
          }
        }
        if (toRemove.length) {
          for (var i = 0; i < toRemove.length; i++) {
            if (!ids.hasOwnProperty(toRemove[i].id)) {
              continue
            }
            channels = _.filter(channels, function(item) {
              return item.id !== toRemove[i].id
            });
          }
        }

        $scope.activeSource._PrivateData.task.channels = angular.copy(channels);
        return allQ;
      };

      function openChannelWindow(source) {
        for (var i = 0; i < source.channels.length; i++) {
          source.channels[i]._assets = assetCache[source.channels[i].id];
        }
        ManageEPGChannelsWindow.Open({
          manageChannelsFn: manageChannelsFromModal,
          title: 'the source "' + (source.name || source.url) + '"',
          filter: {},
          obj: source,
          collection: source.channels,
          currentCollection: _.map(source._PrivateData.task.channels, 'id')
        });
      }

      $scope.openChannelWindow = function (source) {
        var epgIDs = [];
        for (var i = 0; i < source.channels.length; i++) {
          if (assetCache.hasOwnProperty(source.channels[i].id)) {
            continue
          }
          epgIDs.push(source.channels[i].id);
        }
        if (epgIDs.length > 0) {
          var params = {
            'type[eq]': 'channel',
            'epg.id[in]': epgIDs.join(','),
            '$expand': 'epg'
          };
          AssetResource.get(params).$promise
              .then(function (assets) {
                for (var i = 0; i < assets.length; i++) {
                  if (!assetCache.hasOwnProperty(assets[i].epg.id)) {
                    assetCache[assets[i].epg.id] = [];
                  }
                  var asset = _.find(assetCache[assets[i].epg.id], { id: assets[i].id });
                  if (!asset) assetCache[assets[i].epg.id].push(assets[i]);
                }
                openChannelWindow(source);
              })
              .catch(function (reason) {
                $rootScope.debugInfo(reason);
              });
        } else {
          openChannelWindow(source);
        }
      };

      //
      $scope.getChannelEPG = function (source, channel) {
        $scope.loading = true;
        $rootScope.showLinearProgress('#epgEventsLoader');

        var inner = $templateCache.get('epg-channel-schedule.tpl.html');
        inner = $compile(inner)($scope);
        ModalWindowService.Open({
          content: inner,
          isFixed: true,
          clear: true,
          keyboard: true,
          actions: [
            {
              title: 'Cancel',
              color: 'red',
              fn: function () {}
            }
          ],
          size: {
            s: 11,
            l: 8
          }
        });

        $scope.activeChannel = channel;
        $scope.date.currentDate = moment.utc();
        $scope.date.date = $scope.date.currentDate.endOf('day').format("D, MMMM");

        var params = {
          start: parseInt($scope.date.currentDate.startOf('day').unix(), 10),
          end: parseInt($scope.date.currentDate.endOf('day').unix(), 10)
        };

        if ($scope.watcher) $scope.watcher();
        $scope.watcher = $scope.$watch('date.currentDate', function (newValue, oldValue) {
          if (newValue !== oldValue) {
            params = {
              start: parseInt(moment.utc(newValue).startOf('day').format('X'), 10),
              end: parseInt(moment.utc(newValue).endOf('day').format('X'), 10)
            };
            $scope.date.date = moment.utc(newValue).endOf('day').format("D, MMMM");
            $scope.getEvents(source, channel, params);
          }
        });
        $scope.getEvents(source, channel, params);
      };

      $scope.getEvents = function (source, channel, params) {
        $scope.loading = true;
        $rootScope.showLinearProgress('#epgEventsLoader');

        $scope.channelEvents = [];

        EpgService.GetEpgEvents(channel, params)
          .then(function (collection) {
            $scope.loading = false;
            $rootScope.hideLinearProgress('#epgEventsLoader');
            $scope.channelEvents = collection.map(function (event) {
              event._PrivateData = {};
              event._start = moment.utc(event.start * 1000);
              event._end = moment.utc(event.end * 1000);
              return event;
            });
          })
          .catch(function (reason) {
            $scope.loading = false;
            $rootScope.hideLinearProgress('#epgEventsLoader');
            $rootScope.debugInfo(reason);
          });
      };

      $scope.changeView = function(v) {
          $scope.scheduleListView = v;
      };

      $scope.routeSourceId = null;
      if ($routeParams.source_id) {
        $scope.routeSourceId = Number($routeParams.source_id);
      }

      $scope.$on('$routeUpdate', function () {
        if ($scope.routeSourceId && !$routeParams.source_id) {
          $scope.clearActiveSource();
        }
        $scope.routeSourceId = Number($routeParams.source_id) || null;
      });

      $scope.getImportSourceCollection();

      $scope.$on('destroy', function () {
        if ($scope.watcher) $scope.watcher();
      })
    }]);
